export enum SettlementTargetDtoTypeEnum {
  User = 'USER',
  BankAccount = 'BANK_ACCOUNT',
  PlaceholderMember = 'PLACEHOLDER_MEMBER',
}

export interface SettlementTargetDto {
  id: string;
  type: SettlementTargetDtoTypeEnum;
  name: string;
  firstName?: string;
  lastName?: string;
}

/**
 * A transfer party that is a person — registered or not. Both carry firstName/lastName
 * and no `name`, so they render as a member, never as a bank account.
 */
export const isPersonTarget = (target: Pick<SettlementTargetDto, 'type'>): boolean =>
  target.type === SettlementTargetDtoTypeEnum.User ||
  target.type === SettlementTargetDtoTypeEnum.PlaceholderMember;

/** An expense a reimbursement settles, as returned alongside the transfer. */
export interface LinkedExpenseDto {
  id: string;
  title: string;
  amount: number;
  paidAt: string;
}

export interface MoneyTransferDto {
  id: string;
  amount: number;
  date: string;
  from: SettlementTargetDto;
  to: SettlementTargetDto;
  createdAt: string;
  updatedAt: string;
  /** Expenses this reimbursement settles. Absent on a free-standing transfer. */
  expenses?: LinkedExpenseDto[];
}

export interface CreateMoneyTransferDto {
  amount: number;
  date: string;
  fromUserId?: string;
  toUserId?: string;
  fromBankAccountId?: string;
  toBankAccountId?: string;
  /** An unregistered co-owner can be a party to a transfer since api!349. */
  fromPlaceholderMemberId?: string;
  toPlaceholderMemberId?: string;
  /**
   * Expenses this reimbursement settles. The API moves the claim to the sender and refuses
   * an amount that does not match what the selection represents, to the cent.
   */
  expenseIds?: string[];
  /** Fund call line this payment answers: the API moves it to paid (or partly paid). */
  fundCallLineId?: string;
}

/**
 * Édition d'un remboursement. Chaque clé absente laisse la valeur intacte ; `expenseIds`
 * remplace la liste liée en entier — un tableau vide détache toutes les dépenses.
 */
export interface UpdateMoneyTransferDto {
  amount?: number;
  date?: string;
  expenseIds?: string[];
}
